import React, {useState, useMemo} from 'react';
import {
  ChevronDownSmallIcon,
  FolderIcon,
  Button,
  PopOut,
  List,
  ListItem,
  Horizontal,
  Vertical,
  ThemeName,
} from '@taopix/taopix-design-system';
import {Common} from '@taopix/taopix-core';
import {ExternalAssetAlbum} from './../RemoteAssetService';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import {AssetService} from '@taopix/taopix-core/dist/types/types';

export type AssetServiceNavDropdownProps = {
  assetService: AssetService;
  albums: ExternalAssetAlbum[];
  currentAlbumId: string;
  goBack: Function;
  navEnabled: boolean;
};

const AssetServiceNavDropdown = ({
  assetService,
  albums,
  currentAlbumId,
  goBack,
  navEnabled,
}: AssetServiceNavDropdownProps) => {
  const ui = useUiState();
  const [popOutOpen, setPopOutOpen] = useState(false);

  const togglePopOut = () => {
    setPopOutOpen(!popOutOpen);
  };

  const chooseAlbum = (albumid: string) => {
    const goToAlbum = albums?.find(album => album.id === albumid) || ({} as ExternalAssetAlbum);
    const index = albums.indexOf(goToAlbum);
    //how many levels back do we need to go
    const levels = index === 0 ? 1 : albums.length - (index + 1);
    goBack(levels);
    togglePopOut();
  };

  let count = 0;

  const selectedAlbum = useMemo(() => {
    return albums?.find(album => album.id.replaceAll('/', '') === currentAlbumId);
  }, [albums, currentAlbumId]);

  return (
    <>
      <Button
        id="asset-service-nav-menu"
        disabled={!navEnabled}
        startIcon={
          typeof (selectedAlbum?.imgSrc as any) === 'string' ? (
            <FolderIcon />
          ) : (
            (selectedAlbum?.imgSrc as any)
          )
        }
        endIcon={<ChevronDownSmallIcon />}
        buttonStyle={'standard'}
        size={'small'}
        label={
          selectedAlbum &&
          navEnabled &&
          !(assetService.customservice && ['me'].includes(selectedAlbum.id))
            ? selectedAlbum.name
            : Common.getCurrentLocaleString(assetService.name, true)
        }
        onClick={togglePopOut}
        aria-pressed={popOutOpen}
      />

      <PopOut
        offset={{x: 0, y: 0}}
        id={'asset-service-nav-menu-popout'}
        open={popOutOpen}
        anchorId="asset-service-nav-menu"
        displayMode={'positioned'}
        className={'w-[var(--anchorElementWidth)]'}
        repositionOnResize
        anchorOrigin={
          ui.state.isSmallScreen
            ? {vertical: Vertical.Top, horizontal: Horizontal.Centre}
            : {vertical: Vertical.Bottom, horizontal: Horizontal.Centre}
        }
        transformOrigin={
          ui.state.isSmallScreen
            ? {vertical: Vertical.Bottom, horizontal: Horizontal.Centre}
            : {vertical: Vertical.Top, horizontal: Horizontal.Centre}
        }
        onClose={() => setPopOutOpen(false)}
        theme={'tpx-theme-dialogs'}
        themeTip={'Dialogs'}
        contentTheme={ThemeName.Popouts}
      >
        <List>
          {albums
            .map((album: ExternalAssetAlbum) => {
              count++;
              return (
                <ListItem key={count}>
                  <Button
                    label={
                      assetService.customservice && ['me'].includes(album.id)
                        ? Common.getCurrentLocaleString(assetService.name, true)
                        : album.name
                    }
                    value={album.id}
                    buttonStyle={'standard'}
                    size={'small'}
                    corners={'square'}
                    labelAlignment={'left'}
                    startIcon={
                      typeof (album?.imgSrc as any) === 'string' ? (
                        <FolderIcon />
                      ) : (
                        (album?.imgSrc as any)
                      )
                    }
                    onClick={
                      album.id !== currentAlbumId
                        ? () => {
                            chooseAlbum(album.id);
                          }
                        : () => {
                            togglePopOut();
                          }
                    }
                    key={count}
                  />
                </ListItem>
              );
            })
            .filter(c => c)}
        </List>
      </PopOut>
    </>
  );
};

export default AssetServiceNavDropdown;
